import React, { Component } from 'react';
import {
    TableRow, TableCell, IconButton, Collapse, Box, Table, TableHead,
    TableBody, Typography, Chip, Grid,
} from '@material-ui/core';
import { ExpandLess, ExpandMore, ReportProblemRounded } from '@material-ui/icons';

// "-" plutot que 0 quand la valeur est absente : un prix non renseigne et un
// prix a zero ne veulent pas dire la meme chose pour un arbitrage.
export function formatNumber(value) {
    if (value === null || value === undefined || value === "") {
        return "-"
    }
    const nombre = Number(value)
    if (Number.isNaN(nombre)) {
        return "-"
    }
    return nombre.toLocaleString('fr-FR')
}

class ProductRow extends Component {
    state = {
        open: false,
    }

    toggle = () => {
        this.setState({ open: !this.state.open })
    }

    render() {
        const { produit, withStock, priceGap } = this.props;
        const { open } = this.state;

        const comptes = Array.isArray(produit.comptes) ? produit.comptes : []
        const refsAbsorbees = Array.isArray(produit.refs_absorbees) ? produit.refs_absorbees : []
        // Nombre de colonnes de la ligne principale, pour le colSpan du detail
        const detailColSpan = 6

        return (
            <React.Fragment>
                <TableRow hover>
                    <TableCell padding="checkbox">
                        <IconButton
                            size="small"
                            onClick={this.toggle}
                            title={open ? "Replier le detail" : "Voir les comptes et les prix"}
                        >
                            {open ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                    </TableCell>
                    <TableCell>
                        {produit.ref || "-"}
                        {produit.en_collision &&
                            <Chip
                                size="small"
                                color="secondary"
                                icon={<ReportProblemRounded />}
                                label="Collision"
                                style={{ marginLeft: 8 }}
                                title="Regroupement refuse : ce produit attend un arbitrage"
                            />
                        }
                    </TableCell>
                    <TableCell>{produit.name || "-"}</TableCell>
                    <TableCell>{produit.marque || "-"}</TableCell>
                    <TableCell align="right">
                        {comptes.length}
                        {priceGap &&
                            <Chip
                                size="small"
                                variant="outlined"
                                label="prix differents"
                                style={{ marginLeft: 8 }}
                                title="Les comptes n'appliquent pas le meme prix a ce produit"
                            />
                        }
                    </TableCell>
                    <TableCell align="right">{produit.fiches_absorbees || 0}</TableCell>
                </TableRow>

                <TableRow>
                    <TableCell style={{ paddingTop: 0, paddingBottom: 0 }} colSpan={detailColSpan}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box p={2}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="caption" color="textSecondary">Type</Typography>
                                        <Typography variant="body2">{produit.product_type || "-"}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="caption" color="textSecondary">Compte proprietaire</Typography>
                                        <Typography variant="body2">{produit.compte_proprietaire || "-"}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="caption" color="textSecondary">Identifiant</Typography>
                                        <Typography variant="body2">{produit.id || "-"}</Typography>
                                    </Grid>
                                </Grid>

                                {refsAbsorbees.length > 0 &&
                                    <Box pt={2}>
                                        <Typography variant="caption" color="textSecondary">
                                            References absorbees
                                        </Typography>
                                        <Box>
                                            {refsAbsorbees.map((reference, index) => (
                                                <Chip
                                                    key={reference || index}
                                                    size="small"
                                                    label={reference}
                                                    style={{ marginRight: 4, marginTop: 4 }}
                                                />
                                            ))}
                                        </Box>
                                    </Box>
                                }

                                <Box pt={2}>
                                    <Typography variant="subtitle2">
                                        Comptes qui vendent ce produit
                                    </Typography>
                                </Box>

                                {comptes.length === 0
                                    ? <Typography variant="body2" color="textSecondary">
                                        Aucun compte ne vend ce produit.
                                    </Typography>
                                    : <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Compte</TableCell>
                                                <TableCell align="right">Prix HT</TableCell>
                                                <TableCell align="right">Prix TTC</TableCell>
                                                <TableCell align="right">TVA</TableCell>
                                                <TableCell align="right">Reduc. max</TableCell>
                                                <TableCell>Origine</TableCell>
                                                <TableCell>Etat</TableCell>
                                                <TableCell>E-commerce</TableCell>
                                                {withStock && <TableCell align="right">Stock</TableCell>}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {comptes.map((compte, index) => (
                                                <TableRow key={compte.account_id || index}>
                                                    <TableCell>{compte.account_id || "-"}</TableCell>
                                                    <TableCell align="right">{formatNumber(compte.prix_venteHT)}</TableCell>
                                                    <TableCell align="right">{formatNumber(compte.prix_venteTTC)}</TableCell>
                                                    <TableCell align="right">{formatNumber(compte.tva_rate)}</TableCell>
                                                    <TableCell align="right">{formatNumber(compte.reduc_max)}</TableCell>
                                                    <TableCell>{compte.origine || "-"}</TableCell>
                                                    <TableCell>
                                                        {compte.is_disabled
                                                            ? <Chip size="small" label="Desactive" />
                                                            : "Actif"
                                                        }
                                                    </TableCell>
                                                    <TableCell>{compte.ecom_enabled ? "Oui" : "Non"}</TableCell>
                                                    {withStock &&
                                                        <TableCell align="right">{formatNumber(compte.stock)}</TableCell>
                                                    }
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                }
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }
}

export default ProductRow;
